import React, { useMemo } from 'react'
import Text from 'react-text'
import {makeStyles} from 'external/material'
import Button from '@mui/material/Button'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import { useContext } from 'external/react'
import { TeacherContext } from 'teacher/context'
import dayjs from 'dayjs'
import { format } from 'date-fns'

const useStyles = makeStyles({
  add: {
    color: '#fff',
    background: '#2993ff',
    textTransform: 'none',
    '&:hover': {
      background: '#4e576e'
    }
  },
  item: {
    root: {
      minWidth: '200px',
      color: '#4e576e',
      padding: '10px',
      '&:hover': {
        color: '#fff',
        background: '#2993ff'
      }
    }
  }
})

//Discards time info
function getDateString (str = 'T') {
  switch (typeof(str)) {
    case 'string': return str.split('T')[0]
    case 'object': return format(str, 'yyyy-MM-dd')
    default: return ''
  }
}

export default function AddFieldMenu(props) {

  const classes = useStyles()
  const context = useContext(TeacherContext)
  const [anchorEl, setAnchorEl] = React.useState(null)
  const {newPlan: {start, finish, content}} = context

  // We disregard the time so that the days are calculated correctly and allow planning for one day
  const differenceInDays = useMemo(() => {
    const startDate = dayjs(getDateString(start))
    const finishDate = dayjs(getDateString(finish))
    const dayDiff = finishDate.diff(startDate, 'days')
    return isNaN(dayDiff) ? 0 : dayDiff + 1
  }, [start, finish])


  const thereIsAvaliableDays = (content?.dailyPlanning?.length ?? 0) < differenceInDays
  function handleClick(event) {
    setAnchorEl(event.currentTarget)
  }

  function handleClose() {
    setAnchorEl(null);
  }
  
  const fields = props.fields.map((field, key) => {
    return (
      <MenuItem disableGutters={true} className={classes.item} key={key} onClick={() => { field.addItem(); handleClose()}}>
        {field.content.name}
      </MenuItem>
    )
  })

  return (
    <div className="add-field-menu">
      <Button
        aria-controls="customized-menu"
        aria-haspopup="true"
        variant="contained"
        disabled={!thereIsAvaliableDays}
        className={classes.add}
        onClick={(e) => props?.rd ? props.fields.find((_, index) => index === 0).addItem() : handleClick(e)}
      >
        {props?.rd ? <p style={{margin: 0}}>+ Planificación diaria</p> : <Text id="add_field_label" />}
      </Button>
      {props?.rd ? null : 
        <Menu
          elevation={0}
          getContentAnchorEl={null}
          className={classes.menu}
          anchorOrigin={{vertical: 'bottom', horizontal: 'left'}}
          transformOrigin={{vertical: 'top', horizontal: 'left'}}
          id="add-field-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          {fields}
        </Menu>
      }
    </div>
  )
}
